<template>
<div id="helpModal" class="ui modal" >
<div class="scrolling content">


  <div class="ui secondary pointing menu">
    <a class="blue item" data-tab="first">Frequently Asked Questions</a>
    <a class="olive active item" data-tab="second">Contact Us / Report an Issue</a>
    <a class="brown item" data-tab="third">Feature Requests</a>
  </div>


  <div class="ui tab basic segment" data-tab="first" >
    <div class="ui accordion">

      <h5>Products</h5>

      <div class="title"><i class="dropdown icon"></i>
        I have some products I can't see on my dashboard.
      </div>
      <div class="content">
        <p class="transition hidden">
          By default SentryKit will start to track every ASIN that has had a sale recently. Products with an active offer but no sales will be ignored until the first sale occurs to save you on SentryKit fees. <br><br>
          You can change all of these in your <a target="_blank" href="/productsettings">Product Settings</a>.<br><br>
          (Products with no active offer will be excluded from every list)
        </p>
      </div>

     <div class="title"><i class="dropdown icon"></i>
        I have a <i>lot</i> of products, do I have to pick/ignore them one by one?
      </div>
      <div class="content">
        <p class="transition hidden">A bulk edit option is available. Check out the Import/Export section in your <a target="_blank" href="/productsettings">Product Settings</a> at the bottom of the screen.</p>
      </div>

      <div class="title"><i class="dropdown icon"></i>
        Does SentryKit automatically track my new products?
      </div>
      <div class="content">
        <p class="transition hidden">By default, yes. Both new products and long-time inactive products that started selling again (unless they are on your ignore list). <br><br>
        You can change this in your <a target="_blank" href="/productsettings">Product Settings</a>, look for the section directly above the Save button.</p>
      </div>

      <h5>E-mails</h5>

      <div class="title"><i class="dropdown icon"></i>
        Help, sooo many e-mails, what to do?!
      </div>
      <div class="content">
        <p class="transition hidden">
          - <b>To change your alert subscriptions:</b> <a target="_blank" href="/settings">Account Settings</a> -> E-mail -> Manage <br><br>
          - <b>Mute a specific Alert for a Specific ASIN:</b> Select the "Issues" tab on your dashboard. Hover over a product then click the "Mute..." dropdown button.<br><br>
          - <b>Rewise what ASINs</b> you would like SentryKit to track in your <a target="_blank" href="/productsettings">Product Settings</a>.
        </p>
      </div>

      <div class="title"><i class="dropdown icon"></i>
        How can I add a notification e-mail address for a team member?
      </div>
      <div class="content">
        <p class="transition hidden">Head to your <a target="_blank" href="/settings">Account Settings</a>, click "Add New" below your email address. Click "Manage" next to the newly added address to subscribe to alerts and notifications.<br><br>
        - <span style="color:red;"><b>!</b></span> - Please note that these additional email addresses can not be used for log-in.</p>
      </div>

      <div class="title"><i class="dropdown icon"></i>
        Notification for <i>every</i> review not just the critical ones, is that available?
      </div>
      <div class="content">
        <p class="transition hidden">Yes! <a target="_blank" href="/settings">Account Settings</a> -> E-mail -> Manage -> tick the "Notice" checkbox in the first row, then save your settings on the bottom of the screen. All set!</p>
      </div>

       <div class="title"><i class="dropdown icon"></i>
        I'm getting a lot of image change alerts lately, but I didn't change anything.
      </div>
      <div class="content">
        <p class="transition hidden">Amazon recently started swapping between product images. This is usually temporary but the change appears on the Amazon API thus triggering an image change alert in SentryKit. We are looking into ways to filter these more effectively. <br><br>
        - <b>Mute frequently occuring image change alerts</b> right from the alert email: <br>Look for the link reading "*NEW* Don't notify me when the same image change occurs again"</p>
      </div>

      <h5>Other</h5>

      <div class="title"><i class="dropdown icon"></i>
        How does the pricing work?
      </div>
      <div class="content">
        <p class="transition hidden">- SentryKit has a Pay-What-You-Use pricing model. Your monthly fee is based on how many ASINs you track. After connecting your Seller Account SentryKit will add all ASINs to your dashboard that have had at least one sale recently. <br><br>
        - You can change what you track in your <a target="_blank" href="/productsettings">Product Settings</a> at any time - your monthly fee will be recalculated automatically. <br>(Also here: setting to add new ASINs to the dashboard automatically. Default is yes.) <br><br>
        - You can see your current montly fee in your <a target="_blank" href="/settings">Account Settings</a>, next to your Stripe details.
        </p>
      </div>

     <div class="title"><i class="dropdown icon"></i>
        Can I add more Seller Accounts? (How about EU accounts?)
      </div>
      <div class="content">
        <p class="transition hidden">Yes, as many as you want to! ==> <a target="_blank" href="/settings">Account Settings</a>. American and EU/UK marketplaces are all supported.</p>
      </div>

      <!--
      <div class="title"><i class="dropdown icon"></i>
        May I suggest a small tweak (or a big one)?
      </div>
      <div class="content">
        <p class="transition hidden">Absolutelly. We dedicate a good amount of our time to build new features. We maintain a wish-list too, the more something gets asked for the higher it climbs on the list.</p>
      </div>
      -->

      <div class="title"><i class="dropdown icon"></i>
        My question is not listed here...
      </div>
      <div class="content">
        <p class="transition hidden">Send us a quick note in the next tab. We read and respond to every message.</p>
      </div>
      <!--
      <div class="title"><i class="dropdown icon"></i>
        Question?
      </div>
      <div class="content">
        <p class="transition hidden">Answer.</p>
      </div>
      -->

    </div>
  </div>


  <div class="ui tab basic segment" data-tab="second">
    <support-ticket-form ref="issueSupportTicketForm" :category="'issue'" :label="'Question / Issue in detail'" :lastClosedAt="lastClosedAt" />
  </div>


  <div class="ui tab basic segment" data-tab="third">
    <support-ticket-form ref="newFeatureSupportTicketForm" :category="'new_feature'" :label="'Request a new feature'" :lastClosedAt="lastClosedAt" />
  </div>


</div>
<div class="actions">
  <!-- hit ESC or click -->
  <div class="ui black cancel button">Close</div>
</div>

</div>
</template>

<script>
import $ from 'jquery'
import SupportTicketForm from './HelpModal.SupportTicketForm.vue'
export default {
  name: 'helpModal',
  components: {SupportTicketForm},
  data: function () {
    return {
      lastClosedAt: Date.now(),
    }
  },
  methods: {
    hide: () => $('#helpModal').modal('hide'),
    open: () => $('#helpModal').modal('show'),
    resetState: function () {
      this.lastClosedAt = Date.now()
    },
  },
  mounted: function () {
    // init tabs
    // $('#helpModal').modal('show') // .modal({inverted: true})
    $('#helpModal .accordion').accordion()
  },
  destroyed: function () {
    $(this.$el).remove()
  },
}
</script>

<style>

#helpModal .accordion h5,
#helpModal .accordion i.dropdown,
#helpModal .accordion .title.active{color:#0E6EB8;}
#helpModal .accordion .content{
    color: #333;
    padding: 7px;
    border-radius: 5px;
    max-width: 600px;
    transition: background .5s;
    border: 1px solid #008080;
}

</style>



// WEBPACK FOOTER //
// HelpModal.vue?155129b0